export const localFunctionsUrl = 'http://192.168.1.35:5003';
